<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title class="grupos-toolbar flex-wrap pb-2">
	  		    <div class="mb-2 mb-sm-0">
	  		    	<div class="d-flex align-center">
	  		    		<v-icon left color="primary">mdi-account-group-outline</v-icon>
	  		    		<span class="text-h6 font-weight-medium">Grupos</span>
	  		    	</div>
	  		    	<div class="text-caption grey--text text--darken-1 mt-1 d-none d-sm-block">
	  		    		Administra grupos, alumnos y asistencias
	  		    	</div>
	  		    </div>
	  		    <v-spacer></v-spacer>
	  		    <div class="d-flex flex-wrap align-center justify-end" style="gap: 8px;">
            <v-btn
              color="success"
              outlined
              rounded
              small
              class="text-none"
              @click="exportExcel(gruposFiltrados, 'CURSOS_ERP')"
            >
              <v-icon left small>mdi-microsoft-excel</v-icon>
              Excel
            </v-btn>
	  		    <v-btn
              color="deep-orange"
              outlined
              rounded
              small
              class="text-none"
              @click="dialog = true"
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>
            <v-btn
              color="primary"
              outlined
              rounded
              small
              class="text-none"
              :loading="cargar"
              @click="initialize()"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
	  		    </div>
	  		  </v-card-title>
          
	  		  <v-card-text class="pt-2">
	  		  	<v-sheet class="filtros-grupos-sheet rounded-lg pa-4 mb-3" outlined>
	  		  		<div class="d-flex align-center flex-wrap mb-3" style="gap: 8px;">
	  		  			<v-icon color="primary" class="mr-1">mdi-filter-variant</v-icon>
	  		  			<span class="text-subtitle-2 font-weight-medium">Filtros</span>
	  		  			<v-btn
	  		  				v-if="filtrosActivos"
	  		  				text
	  		  				x-small
	  		  				color="primary"
	  		  				class="text-none ml-1"
	  		  				@click="limpiarFiltros"
	  		  			>
	  		  				<v-icon left x-small>mdi-filter-off-outline</v-icon>
	  		  				Limpiar filtros
	  		  			</v-btn>
	  		  		</div>
	  		  		<v-row dense>
	  		  			<v-col cols="12" sm="6" md="3">
	  		  				<v-autocomplete
	  		  					v-model="filterPlantel"
	  		  					:items="opcionesPlantelFiltro"
	  		  					label="Plantel"
	  		  					dense
	  		  					outlined
	  		  					clearable
	  		  					hide-details
	  		  					prepend-inner-icon="mdi-office-building-outline"
	  		  					no-data-text="Sin datos en listado"
	  		  				/>
	  		  			</v-col>
	  		  			<v-col cols="12" sm="6" md="3">
	  		  				<v-autocomplete
	  		  					v-model="filterCurso"
	  		  					:items="opcionesCursoFiltro"
	  		  					label="Curso"
	  		  					dense
	  		  					outlined
	  		  					clearable
	  		  					hide-details
	  		  					prepend-inner-icon="mdi-book-open-variant"
	  		  					no-data-text="Sin datos en listado"
	  		  				/>
	  		  			</v-col>
	  		  			<v-col cols="12" sm="6" md="3">
	  		  				<v-autocomplete
	  		  					v-model="filterHorario"
	  		  					:items="opcionesHorarioFiltro"
	  		  					label="Horario"
	  		  					dense
	  		  					outlined
	  		  					clearable
	  		  					hide-details
	  		  					prepend-inner-icon="mdi-clock-outline"
	  		  					no-data-text="Sin datos en listado"
	  		  				/>
	  		  			</v-col>
	  		  			<v-col cols="12" sm="6" md="3">
	  		  				<v-autocomplete
	  		  					v-model="filterMaestro"
	  		  					:items="opcionesMaestroFiltro"
	  		  					label="Maestro"
	  		  					dense
	  		  					outlined
	  		  					clearable
	  		  					hide-details
	  		  					prepend-inner-icon="mdi-account-tie-outline"
	  		  					no-data-text="Sin datos en listado"
	  		  				/>
	  		  			</v-col>
	  		  		</v-row>
	  		  	</v-sheet>

	  		  	<v-row v-if="kpiGruposPorPlantel.length" dense class="mb-3">
	  		  		<v-col cols="12">
	  		  			<div class="d-flex align-center flex-wrap mb-2" style="gap: 8px;">
	  		  				<v-icon color="primary">mdi-chart-donut</v-icon>
	  		  				<span class="text-subtitle-2 font-weight-medium">Grupos por plantel</span>
	  		  				<v-chip x-small outlined color="grey darken-1">
	  		  					{{ grupos.length }} en total
	  		  				</v-chip>
	  		  			</div>
	  		  			<v-row dense>
	  		  				<v-col
	  		  					v-for="item in kpiGruposPorPlantel"
	  		  					:key="item.plantel"
	  		  					cols="6"
	  		  					sm="4"
	  		  					md="3"
	  		  					lg="2"
	  		  				>
	  		  					<v-sheet
	  		  						rounded
	  		  						class="pa-3 kpi-plantel-sheet text-center"
	  		  						:class="'kpi-plantel-sheet--' + item.tone"
	  		  						elevation="0"
	  		  					>
	  		  						<div
	  		  							class="text-caption font-weight-medium text-uppercase kpi-plantel-nombre text-truncate"
	  		  							:title="item.plantel"
	  		  						>
	  		  							{{ item.plantel }}
	  		  						</div>
	  		  						<div class="text-h5 font-weight-bold mt-1 kpi-plantel-numero">{{ item.count }}</div>
	  		  						<div class="text-caption kpi-plantel-sublabel">grupos</div>
	  		  					</v-sheet>
	  		  				</v-col>
	  		  			</v-row>
	  		  		</v-col>
	  		  	</v-row>

	  		  	<v-row align="center" dense class="mb-2">
	  		  		<v-col cols="12" md="6">
	  		  			<v-text-field
	  		  				label="Buscar en tabla"
	  		  				placeholder="ID, plantel, curso…"
	  		  				outlined
	  		  				dense
	  		  				hide-details
	  		  				clearable
	  		  				prepend-inner-icon="mdi-magnify"
	  		  				v-model="search"
	  		  			/>
	  		  		</v-col>
	  		  		<v-col cols="12" md="6" class="text-md-right text-caption grey--text">
	  		  			<span v-if="grupos.length">{{ gruposFiltrados.length }} de {{ grupos.length }} grupos</span>
	  		  		</v-col>
	  		  	</v-row>

	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="gruposFiltrados"
							    class="grupos-table elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>
							  

							    <template v-slot:item.actions="{ item }">
							    	<div class="d-flex align-center flex-wrap acciones-grupo">
							    		<v-tooltip bottom>
							    			<template v-slot:activator="{ on, attrs }">
							    				<v-btn
							    					v-bind="attrs"
							    					v-on="on"
							    					icon
							    					x-small
							    					class="mr-1"
							    					color="deep-purple"
							    					@click="editItemAlumnos(item)"
							    				>
							    					<v-icon small>mdi-account-multiple-outline</v-icon>
							    				</v-btn>
							    			</template>
							    			<span>Alumnos del grupo</span>
							    		</v-tooltip>
							    		<v-tooltip bottom>
							    			<template v-slot:activator="{ on, attrs }">
							    				<v-btn
							    					v-bind="attrs"
							    					v-on="on"
							    					icon
							    					x-small
							    					class="mr-1"
							    					color="primary"
							    					@click="editItem(item)"
							    				>
							    					<v-icon small>mdi-pencil-outline</v-icon>
							    				</v-btn>
							    			</template>
							    			<span>Editar grupo</span>
							    		</v-tooltip>
							    		<v-tooltip bottom>
							    			<template v-slot:activator="{ on, attrs }">
							    				<v-btn
							    					v-bind="attrs"
							    					v-on="on"
							    					icon
							    					x-small
							    					class="mr-1"
							    					color="teal"
							    					@click="alumnosAsistencia(item)"
							    				>
							    					<v-icon small>mdi-clipboard-text-clock-outline</v-icon>
							    				</v-btn>
							    			</template>
							    			<span>Asistencia</span>
							    		</v-tooltip>
							    		<v-tooltip bottom>
							    			<template v-slot:activator="{ on, attrs }">
							    				<v-btn
							    					v-bind="attrs"
							    					v-on="on"
							    					icon
							    					x-small
							    					color="error"
							    					outlined
							    					@click="deleteItem(item)"
							    				>
							    					<v-icon small>mdi-delete-outline</v-icon>
							    				</v-btn>
							    			</template>
							    			<span>Eliminar grupo</span>
							    		</v-tooltip>
							    	</div>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idgrupos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>


            <v-col cols="12" md="6">
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idplanteles"
			          :items="planteles"
			          label="Selecciona un plantel"
			          hide-details
			          item-text="plantel"
			          item-value="id_plantel"
			        >
			        </v-autocomplete>
            </v-col>

           <v-col cols="12" md="6">
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idcursos"
			          :items="cursos"
			          label="Selecciona un curso"
			          hide-details
			          item-text="curso"
			          item-value="idcursos"
			        >
			        </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idhorarios"
			          :items="horarios"
			          label="Selecciona un horario"
			          hide-details
			          item-text="horario"
			          item-value="idhorarios"
			        >
			        </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
	          	<v-text-field
	          		v-model="editedItem.cupo"
	          		dense
	          		hide-details
	          		filled
	          		type="number"
	          		label="Cupo"
	          	>
	          	</v-text-field>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="6">
	          	<v-text-field
	          		v-model="editedItem.fechainicio"
	          		dense
	          		hide-details
	          		filled
	          		type="date"
	          		label="Fecha inicio"
	          	>
	          	</v-text-field>
            </v-col>

            <v-col cols="12" md="6">
	          	<v-text-field
	          		v-model="editedItem.fechafinal"
	          		dense
	          		hide-details
	          		filled
	          		type="date"
	          		label="fecha final"
	          	>
	          	</v-text-field>
            </v-col>

            <v-col cols="12" >
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idmaestros"
			          :items="teachers"
			          label="Selecciona un teacher"
			          hide-details
			          item-text="nomuser"
			          item-value="id"
			        >
			        </v-autocomplete>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ver los alumnos -->
	  <v-dialog
      v-model="dialogAlumnos"
      max-width="960px"
      persistent
      scrollable
    >
      <v-card class="dialog-alumnos-grupo">
        <v-card-title class="dialog-alumnos-grupo__head pb-2">
        	<div class="d-flex align-center flex-wrap" style="gap: 8px;">
        		<v-icon color="primary">mdi-account-school-outline</v-icon>
        		<div>
        			<div class="text-h6 font-weight-medium">Alumnos del grupo</div>
        			<div class="text-caption grey--text text--darken-1">
        				Inscribe alumnos y activa o desactiva su participación
        			</div>
        		</div>
        	</div>
        	<v-spacer></v-spacer>
        	<v-chip small outlined color="primary" class="font-weight-medium">
        		ID grupo {{ editedItem.idgrupos }}
        	</v-chip>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pt-4">
        	<v-sheet class="dialog-alumnos-grupo__add rounded-lg pa-4 mb-4" outlined>
        		<div class="text-subtitle-2 font-weight-medium mb-3 d-flex align-center">
        			<v-icon small color="primary" class="mr-2">mdi-account-plus-outline</v-icon>
        			Agregar alumno al grupo
        		</div>
        		<v-row align="center" dense>
        			<v-col cols="12" md="9">
        				<v-autocomplete
			          outlined
			          dense
			          clearable
			          hide-details
			          v-model="alumno"
			          :items="alumnos"
			          label="Buscar y seleccionar alumno"
			          placeholder="Nombre del alumno…"
			          return-object
			          prepend-inner-icon="mdi-magnify"
			          item-text="nombre_completo"
			          item-value="idalumnos"
			          no-data-text="Sin coincidencias"
			        />
        			</v-col>
        			<v-col cols="12" md="3" class="d-flex">
        				<v-btn
        					color="primary"
        					depressed
        					block
        					class="text-none"
        					rounded
        					:disabled="!alumno"
        					:loading="cargar"
        					@click="saveAlumno()"
        				>
        					<v-icon left small>mdi-account-plus</v-icon>
        					Agregar
        				</v-btn>
        			</v-col>
        		</v-row>
        		<div class="text-caption grey--text mt-2">
        			<v-icon x-small class="mr-1">mdi-information-outline</v-icon>
        			El alumno se registra <strong>activo</strong> por defecto.
        		</div>
        	</v-sheet>

          <v-row dense>
          	<v-col cols="12">
						  <v-data-table
						    :headers="headersAlumnos"
						    :items="inscritos"
						    class="alumnos-grupo-table elevation-0"
						    :mobile-breakpoint="100"
		            dense
						  >
						    <template v-slot:item.actions="{ item }">
						    	<v-tooltip bottom>
						    		<template v-slot:activator="{ on, attrs }">
						    			<v-btn
						    				v-bind="attrs"
						    				v-on="on"
						    				color="error"
						    				icon
						    				x-small
						    				outlined
						    				@click="deleteItemAlumnos(item)"
						    			>
						    	      <v-icon small>mdi-delete-outline</v-icon>
						    			</v-btn>
						    		</template>
						    		<span>Quitar del grupo</span>
						    	</v-tooltip>
						    </template>

						    <template v-slot:item.estatus="{ item }">
						    	<div class="d-flex align-center">
						    		<v-switch
							      v-model="item.estatus"
							      :true-value="1"
							      :false-value="0"
							      color="success"
							      inset
							      dense
							      hide-details
							      class="mt-0"
							      @change="updateEstatusAlumnoGrupo(item)"
							    />
							    <span class="text-caption ml-1 d-none d-sm-inline grey--text">
							    	{{ item.estatus === 1 ? 'Activo' : 'Inactivo' }}
							    </span>
						    	</div>
						    </template>

						    <template v-slot:no-data>
						    	<div class="text-center py-8 grey--text">
						    		<v-icon size="48" color="grey lighten-1">mdi-account-off-outline</v-icon>
						    		<div class="mt-2">No hay alumnos en este grupo</div>
						    		<v-btn
						    			color="primary"
						    			text
						    			small
						    			class="mt-2"
						    			@click="editItemAlumnos(editedItem)"
						    		>
						    			<v-icon left small>mdi-refresh</v-icon>
						    			Reintentar carga
						    		</v-btn>
						    	</div>
						    </template>

						  </v-data-table>
  		    	</v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="text-none"
            @click="closeAlumnos"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el grupo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDeleteAlumno" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el alumno del grupo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeAlumnos()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirmAlumno()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosAsistencia"
      max-width="1200px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de asistencia</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
        	<v-row>
        		<v-col cols="12" md="6" lg="4">
		          <v-text-field
		            v-model="fechainicio"
		            label="Fecha de inicio"
		            filled
		            type="date"
		          ></v-text-field>
        		</v-col>
        		<v-col cols="12" md="6" lg="4">
		          <v-text-field
		            v-model="fechafinal"
		            label="Fecha de final"
		            filled
		            type="date"
		          ></v-text-field>
        		</v-col>
        		<v-col cols="12" md="6" lg="4">
		          <v-btn @click="alumnosAsistencia( editedItem )">Consultar</v-btn>
        		</v-col>
        	</v-row>

        	<v-row>
        		<v-col cols="12">
        			<div>
						    <h2 class="text-xl font-bold mb-4">Reporte de Asistencias</h2>

						    <div v-for="semana in semanasUnicas" :key="semana" class="mb-8">
						      <h3 class="text-lg font-semibold mb-2">Semana {{ semana }}</h3>

						      <table class="w-full border border-gray-300 text-sm">
						        <thead class="bg-gray-100">
						          <tr>
						            <th class="border px-2 py-1">Alumno</th>
						            <th class="border px-2 py-1">Tutor</th>
						            <th class="border px-2 py-1">Tel. Alumno</th>
						            <th class="border px-2 py-1">Tel. Tutor</th>
						            <th class="border px-2 py-1">Folio</th>
						            <th v-for="dia in diasPorSemana[semana]" :key="dia" class="border px-2 py-1">
						              {{ dia }}
						            </th>
						          </tr>
						        </thead>
						        <tbody>
						          <tr v-for="alumno in alumnosPorSemana(semana)" :key="alumno.idalumnos">
						            <td class="border px-2 py-1">{{ alumno.nombre_alumno }}</td>
						            <td class="border px-2 py-1">{{ alumno.nombre_tutor }}</td>
						            <td class="border px-2 py-1">{{ alumno.telefono_alumno }}</td>
						            <td class="border px-2 py-1">{{ alumno.telefono_tutor }}</td>
						            <td class="border px-2 py-1">{{ alumno.semanas.find(s => s.semana === semana)?.folio || '-' }}</td>
						            <td
						              v-for="dia in diasPorSemana[semana]"
						              :key="dia"
						              class="border px-2 py-1 text-center"
						            >
						              {{
						                getValorAsistencia(alumno, semana, dia)
						              }}
						            </td>
						          </tr>
						        </tbody>
						      </table>
						    </div>
						  </div>
        		</v-col>
        	</v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            top
            absolute
            right
            @click="dialogAlumnosAsistencia = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

			  	<v-spacer></v-spacer>
			    <v-btn
			    	color="green"
	  				dark 
	  				block
	  				outlined
	  				@click="enviarAsistencias( editedItem )" 
	  			>
	  				<v-icon small left>mdi-content-save</v-icon>
	  				<span >Guardar</span>
	  			</v-btn>
			  </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import dayjs from 'dayjs'
	import isoWeek from 'dayjs/plugin/isoWeek'
	dayjs.extend(isoWeek)

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      grupos: [],

      filterPlantel: null,
      filterCurso: null,
      filterHorario: null,
      filterMaestro: null,

      headers: [
        { text: 'ID'         , value: 'idgrupos'       },
        { text: 'Plantel'    , value: 'plantel'        },
        { text: 'Curso'      , value: 'curso'          },
        { text: 'Horario'    , value: 'horario'        },
        { text: 'Inicia'     , value: 'fechainicio'    },
        { text: 'Termina'    , value: 'fechafinal'     },
        { text: 'Maestro'    , value: 'maestro'        },
        { text: 'Fecha Alta' , value: 'fecha_creacion' },
        { text: 'Acciones'   , value: 'actions', sortable: false },
      ],

      headersAlumnos: [
        { text: 'ID'       , value: 'idgruposalumnos'  },
        { text: 'Alumno'   , value: 'alumno'           },
        { text: 'Teléfono' , value: 'telefono'         },
        { text: 'Edad'     , value: 'edad'             },
        { text: 'Estatus'  , value: 'estatus'          },
        { text: 'Correo'   , value: 'correo'           },
        { text: 'Acciones' , value: 'actions', sortable: false },
      ],



      cursos:[],
      horarios:[],
      planteles:[],
      alumnos:[],
      inscritos:[],
      teachers:[],
      dialogAlumnos:false,
      alumno: null,

      deleteAlumno: {
        idgruposalumnos:0,
        deleted: 0
      },

      listaalumnos:[],
      dialogDeleteAlumno: false,
      dialogAlumnosAsistencia: false,
      fecha_asistencia: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechainicio: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fechafinal: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			menu: false,
      fechasHabiles:["2025-04-23"],
			fechaMin:null,
			fechaMax:null,
      headersAlumnosAsistencia: [
        { text: 'ID'         , value: 'idalumnos'          },
        { text: 'Plantel'    , value: 'nombre_alumno'      },
        { text: 'Curso'      , value: 'semana'             },
        { text: 'Horario'    , value: 'fecha'              },
        { text: 'Inicia'     , value: 'valor_asistencia'   },
        { text: 'Termina'    , value: 'folio'              },
        { text: 'Fecha Alta' , value: 'telefono_alumno'    },
        { text: 'Maestro'    , value: 'nombre_tutor'       },
        { text: 'Fecha Alta' , value: 'telefono_tutor'     },
      ],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar grupo' : 'Editar grupo'
      },

      filtrosActivos () {
        return !!(this.filterPlantel || this.filterCurso || this.filterHorario || this.filterMaestro)
      },

      opcionesPlantelFiltro () {
        const arr = [...new Set((this.grupos || []).map(g => g.plantel).filter(Boolean))]
        return arr.sort((a, b) => String(a).localeCompare(String(b), 'es'))
      },

      opcionesCursoFiltro () {
        const arr = [...new Set((this.grupos || []).map(g => g.curso).filter(Boolean))]
        return arr.sort((a, b) => String(a).localeCompare(String(b), 'es'))
      },

      opcionesHorarioFiltro () {
        const arr = [...new Set((this.grupos || []).map(g => g.horario).filter(Boolean))]
        return arr.sort((a, b) => String(a).localeCompare(String(b), 'es'))
      },

      opcionesMaestroFiltro () {
        const arr = [...new Set((this.grupos || []).map(g => g.maestro).filter(Boolean))]
        return arr.sort((a, b) => String(a).localeCompare(String(b), 'es'))
      },

      gruposFiltrados () {
        let rows = Array.isArray(this.grupos) ? [...this.grupos] : []
        if (this.filterPlantel) {
          rows = rows.filter(g => (g.plantel || '') === this.filterPlantel)
        }
        if (this.filterCurso) {
          rows = rows.filter(g => (g.curso || '') === this.filterCurso)
        }
        if (this.filterHorario) {
          rows = rows.filter(g => (g.horario || '') === this.filterHorario)
        }
        if (this.filterMaestro) {
          rows = rows.filter(g => (g.maestro || '') === this.filterMaestro)
        }
        return rows
      },

      kpiGruposPorPlantel () {
        const map = {}
        for (const g of this.grupos || []) {
          const key = (g.plantel || '').trim() || '(Sin plantel)'
          map[key] = (map[key] || 0) + 1
        }
        const tones = ['blue', 'purple', 'teal', 'amber', 'deep-orange', 'cyan', 'indigo', 'green']
        return Object.entries(map)
          .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'es'))
          .map(([plantel, count], i) => ({
            plantel,
            count,
            tone: tones[i % tones.length]
          }))
      },

      semanasUnicas() {
	      const semanas = new Set()
	      this.listaalumnos.forEach(alumno => {
	        alumno.semanas.forEach(s => semanas.add(s.semana))
	      })
	      return Array.from(semanas).sort()
	    },
	    
	    diasPorSemana() {
	      const map = {}
	      this.semanasUnicas.forEach(semana => {
	        // Buscar la primera fecha que caiga en esa semana
	        const dias = []
	        let fecha = dayjs().startOf('year')
	        while (fecha.isoWeek() !== parseInt(semana)) {
	          fecha = fecha.add(1, 'day')
	        }
	        for (let i = 0; i < 7; i++) {
	          if (fecha.day() >= 1 && fecha.day() <= 5) {
	            dias.push(fecha.format('YYYY-MM-DD'))
	          }
	          fecha = fecha.add(1, 'day')
	        }
	        map[semana] = dias
	      })
	      return map
	    }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogAlumnos ( val ){
      	val || this.closeAlumnos( )
      }

    },

    async created () {
      await this.initialize()
      await this.getCursos()
      await this.getPlanteles()
      await this.getHorarios()
      await this.getUsuarios()
      await this.getAlumnos()
    },

    methods: {
      limpiarFiltros () {
        this.filterPlantel = null
        this.filterCurso = null
        this.filterHorario = null
        this.filterMaestro = null
      },

      initialize () {
      	this.cargar = true
        this.grupos = []
        return this.$http.get('grupos.list').then(response=>{
        	this.grupos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCursos () {
      	this.cargar = true
        this.cursos = []
        return this.$http.get('cursos.list').then(response=>{
        	this.cursos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.list.erp').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
      	this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.list').then(response=>{
        	this.horarios = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
      	this.cargar = true
        this.usuarios = []
        return this.$http.get('users').then(response=>{
        	this.usuarios = response.data
        	this.teachers = response.data.filter( el => el.idpuestos == 27 )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getAlumnos () {
      	this.cargar = true
        this.alumnos = []
        return this.$http.get('alumnos.list').then(response=>{
        	this.alumnos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      editItemAlumnos (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)

      	this.cargar = true
        this.inscritos = []

        return this.$http.get('grupos.alumnos/' + this.editedItem.idgrupos ).then(response=>{
        	const rows = response.data || []
        	this.inscritos = rows.map(row => ({
        	  ...row,
        	  estatus: Number(row.estatus) === 1 ? 1 : 0,
        	}))
        	this.cargar      = false
        	this.dialogAlumnos = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })


      },

      deleteItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemAlumnos( item ){

        this.deleteAlumno = Object.assign({}, item)
        this.dialogDeleteAlumno = true

      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('grupos.update/' + this.editedItem.idgrupos, this.editedItem).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize () 
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteItemConfirmAlumno () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.deleteAlumno.deleted = 1
        this.$http.put('grupos.alumnos/' + this.deleteAlumno.idgruposalumnos, this.deleteAlumno).then(response=>{
          this.validarSuccess( response.data.message )
          this.editItemAlumnos (this.editedItem) 
          this.dialogDeleteAlumno = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeAlumnos () {
        this.dialogAlumnos = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('grupos.update/' + this.editedItem.idgrupos, this.editedItem).then(response=>{
        		this.close()
          	this.validarSuccess( response.data.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('grupos.add', this.editedItem).then(response=>{
        		this.close()
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },

      saveAlumno() {
        if (!this.alumno || !this.alumno.idalumnos) {
          this.parametros.mensaje = 'Selecciona un alumno de la lista para agregarlo.'
          this.parametros.dialogError = true
          this.parametros.color = 'warning'
          this.respuestaAlerta = true
          return
        }
	      this.cargar = true
        const payload = Object.assign({}, this.alumno, {
          idgrupos: this.editedItem.idgrupos,
          estatus: 1,
        })
        this.$http.post('grupos.alumnos', payload).then(response=>{
      		this.alumno = null
        	this.editItemAlumnos(this.editedItem)
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      alumnosAsistencia(item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.fechaMin = this.editedItem.fechainicio
				this.fechaMax = this.editedItem.fechafinal

      	this.cargar = true
        this.listaalumnos = []

        let payload = {
        	idgrupos   : this.editedItem.idgrupos,
        	fechafinal : this.fechafinal,
        	fechainicio: this.fechainicio,
        }


        return this.$http.post('reporte.alumnos.asistencia', payload ).then(response=>{
        	this.listaalumnos = response.data
        	this.cargar      = false
        	this.dialogAlumnosAsistencia = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })


      },

      updateEstatusAlumnoGrupo( value ){

      	return this.$http.post('update.estatus.grupoalumno', value ).then(response=>{

        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      alumnosPorSemana(semana) {
	      return this.listaalumnos.filter(alumno =>
	        alumno.semanas.some(s => s.semana === semana)
	      )
	    },
	    getValorAsistencia(alumno, semana, dia) {
	      const semanaData = alumno.semanas.find(s => s.semana === semana)
	      if (!semanaData) return '-'
	      const valor = semanaData.asistencias[dia]
	      if (valor === 1) return '✔️'
	      if (valor === 2) return '❌'
	      if (valor === 3) return '⏰'
	      return '-'
	    }

    },
  }
</script>



<style scoped>
	table {
	  border-collapse: collapse;
	}

	.filtros-grupos-sheet {
	  background: linear-gradient(180deg, rgba(25, 118, 210, 0.04) 0%, transparent 100%);
	}

	.grupos-toolbar {
	  row-gap: 8px;
	}

	.grupos-table ::v-deep thead {
	  background: #f5f7fa;
	}

	.grupos-table ::v-deep th {
	  font-weight: 600 !important;
	  font-size: 0.75rem !important;
	  letter-spacing: 0.04em;
	  color: rgba(0, 0, 0, 0.62) !important;
	  white-space: nowrap;
	}

	.grupos-table ::v-deep tbody tr:hover {
	  background: rgba(25, 118, 210, 0.04) !important;
	}

	.acciones-grupo {
	  gap: 2px;
	}

	.kpi-plantel-sheet {
	  border: 1px solid rgba(0, 0, 0, 0.06);
	  border-top-width: 3px;
	  min-height: 92px;
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	}

	.kpi-plantel-sheet--blue {
	  border-top-color: #1976d2;
	  background: linear-gradient(160deg, #e3f2fd 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--blue .kpi-plantel-numero { color: #0d47a1; }
	.kpi-plantel-sheet--blue .kpi-plantel-nombre { color: #1565c0; }

	.kpi-plantel-sheet--purple {
	  border-top-color: #7b1fa2;
	  background: linear-gradient(160deg, #f3e5f5 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--purple .kpi-plantel-numero { color: #4a148c; }
	.kpi-plantel-sheet--purple .kpi-plantel-nombre { color: #6a1b9a; }

	.kpi-plantel-sheet--teal {
	  border-top-color: #00796b;
	  background: linear-gradient(160deg, #e0f2f1 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--teal .kpi-plantel-numero { color: #004d40; }
	.kpi-plantel-sheet--teal .kpi-plantel-nombre { color: #00695c; }

	.kpi-plantel-sheet--amber {
	  border-top-color: #ff8f00;
	  background: linear-gradient(160deg, #fff8e1 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--amber .kpi-plantel-numero { color: #e65100; }
	.kpi-plantel-sheet--amber .kpi-plantel-nombre { color: #ef6c00; }

	.kpi-plantel-sheet--deep-orange {
	  border-top-color: #d84315;
	  background: linear-gradient(160deg, #fbe9e7 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--deep-orange .kpi-plantel-numero { color: #bf360c; }
	.kpi-plantel-sheet--deep-orange .kpi-plantel-nombre { color: #d84315; }

	.kpi-plantel-sheet--cyan {
	  border-top-color: #00838f;
	  background: linear-gradient(160deg, #e0f7fa 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--cyan .kpi-plantel-numero { color: #006064; }
	.kpi-plantel-sheet--cyan .kpi-plantel-nombre { color: #00838f; }

	.kpi-plantel-sheet--indigo {
	  border-top-color: #283593;
	  background: linear-gradient(160deg, #e8eaf6 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--indigo .kpi-plantel-numero { color: #1a237e; }
	.kpi-plantel-sheet--indigo .kpi-plantel-nombre { color: #283593; }

	.kpi-plantel-sheet--green {
	  border-top-color: #2e7d32;
	  background: linear-gradient(160deg, #e8f5e9 0%, #fafafa 55%);
	}
	.kpi-plantel-sheet--green .kpi-plantel-numero { color: #1b5e20; }
	.kpi-plantel-sheet--green .kpi-plantel-nombre { color: #2e7d32; }

	.kpi-plantel-sublabel {
	  opacity: 0.72;
	  margin-top: 2px;
	}

	.dialog-alumnos-grupo__head {
	  background: linear-gradient(180deg, rgba(25, 118, 210, 0.06) 0%, transparent 100%);
	}

	.dialog-alumnos-grupo__add {
	  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(255, 255, 255, 0.9) 100%);
	}

	.alumnos-grupo-table ::v-deep thead {
	  background: #f5f7fa;
	}

	.alumnos-grupo-table ::v-deep th {
	  font-weight: 600 !important;
	  font-size: 0.75rem !important;
	  letter-spacing: 0.03em;
	  color: rgba(0, 0, 0, 0.62) !important;
	}

	.alumnos-grupo-table ::v-deep tbody tr:hover {
	  background: rgba(25, 118, 210, 0.04) !important;
	}
</style>